export default ((root, options) => {
  options = Object.assign({
    indicatorSelector: '.wizard-indicator',
    itemSelector: '.wizard-item',
    controlsSelector: 'button.wizard-control',
    changeOnClick: false,
    changeOnClickPast: false,
    messages: {
      'error_do_not_skip_steps': "Doorloop eerst het volledige stappenplan voor u verder kunt naar deze stap!"
    }
  }, options);
  if (typeof root === 'string') {
    root = document.querySelector(root);
  }
  const form = root.closest('form');
  let activeItemIndex = 0;
  const indicators = Array.prototype.slice.call(root.querySelectorAll(options.indicatorSelector));
  const items = Array.prototype.slice.call(root.querySelectorAll(options.itemSelector));
  const itemLength = items.length;
  const updateItem = function () {
    for (let i = 0; i < indicators.length; i++) {
      const indicator = indicators[i];
      if (i === activeItemIndex) {
        indicator.classList.add('active');
        indicator.setAttribute('data-opened-before', true);
      } else {
        indicator.classList.remove('active');
      }
    }
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (i === activeItemIndex) {
        item.removeAttribute('hidden');
      } else {
        item.setAttribute('hidden', true);
      }
    }
  };
  updateItem();
  const previousItem = function (event) {
    if (activeItemIndex <= 0) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    activeItemIndex -= 1;
    updateItem();
  };
  const nextItem = function (event) {
    if (activeItemIndex >= itemLength - 1) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    if (form) {
      const item = items[activeItemIndex];

      // Validate fields before continue-ing.
      const invalid = [];
      const inputs = item.querySelectorAll('input');
      for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i];
        if (input.willValidate && !input.validity.valid) {
          invalid.push(input);
        }
      }
      const selects = item.querySelectorAll('select');
      for (let i = 0; i < selects.length; i++) {
        const select = selects[i];
        if (select.willValidate && !select.validity.valid) {
          invalid.push(select);
        }
      }
      if (invalid.length > 0) {
        form.reportValidity();
        return;
      }
    }
    activeItemIndex += 1;
    updateItem();
  };
  const setupIndicator = function (indicator, indicatorIndex, itemIndex) {
    if (indicator.getAttribute('data-index') == null) {
      indicator.setAttribute('data-index', indicatorIndex);
      if (indicatorIndex == 0) {
        indicator.setAttribute('data-opened-before', true);
      } else {
        indicator.setAttribute('data-opened-before', false);
      }
      if (options.changeOnClick || options.changeOnClickPast) {
        indicator.addEventListener('click', event => {
          const clickedIndex = parseInt(event.currentTarget.getAttribute('data-index'));
          const openedBefore = event.currentTarget.getAttribute('data-opened-before') == 'true' ? true : false;
          if (options.changeOnClick) {
            activeItemIndex = clickedIndex;
            updateItem();
          } else if (options.changeOnClickPast) {
            if (openedBefore || clickedIndex == activeItemIndex + 1) {
              activeItemIndex = clickedIndex;
              updateItem();
            } else {
              event.preventDefault();
              event.stopPropagation();
              alert(options.messages['error_do_not_skip_steps']);
              return;
            }
          }
        });
      }
    }
  };
  const setupControl = function (button, itemIndex) {
    const isNext = button.getAttribute('type') === 'submit' || button.getAttribute('data-wizard-control') === 'next';
    if (isNext) {
      // Don't override final submit button.
      if (itemIndex === itemLength - 1) {
        return;
      }
      button.addEventListener('click', nextItem);
    } else {
      // Hide previous button on first slide.
      if (itemIndex === 0) {
        button.setAttribute('hidden', true);
      }
      button.addEventListener('click', previousItem);
    }
  };
  const setupItem = function (item, itemIndex) {
    const indicators = root.querySelectorAll(options.indicatorSelector);
    for (let i = 0; i < indicators.length; i++) {
      setupIndicator(indicators[i], i, itemIndex);
    }
    const controls = item.querySelectorAll(options.controlsSelector);
    for (let i = 0; i < controls.length; i++) {
      setupControl(controls[i], itemIndex);
    }
  };
  for (let i = 0; i < itemLength; i++) {
    setupItem(items[i], i);
  }
});